import {UmpireSquad} from '../umpire-squad';
import {UmpireImage} from '../umpire-image';
import {UmpireClub} from '../umpire-club';

export interface UmpireTeam {
  client_id: number;

  id: string;

  image: Partial<UmpireImage>;

  name: string;

  relationshipNames: string[];

  squads: Partial<UmpireSquad>[];

  type: string;

  is_main: boolean;

  club: Partial<UmpireClub>;

  slug: string | null;
}
